import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { JsonLoaderService } from '../../core/services/json-loader.service';
import { ActivatedRoute } from '@angular/router';
import { FormType } from '../../core/services/lgv-form-utility.service';

@Component({
    selector: 'lgv-short-loan-app-page',
    templateUrl: './short-loan-app-page.component.html',
    styleUrls: ['./short-loan-app-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShortLoanAppPageComponent implements OnInit, OnDestroy {
    appId$ = new BehaviorSubject(null);
    level1$ = new BehaviorSubject(-1);
    level2$ = new BehaviorSubject(-1);
    defaultModel = {
        "loanApp": {
        }
    };
    formType = FormType.PreQual;
    onDestroy$ = new Subject();
    constructor(public jsonLoader: JsonLoaderService,
        private route: ActivatedRoute
    ) {
        this.route.params.pipe(takeUntil(this.onDestroy$)).subscribe(params => {
            if (params['appId']) {
                this.appId$.next(params['appId']);
            }
            if (params['level1']) {
                this.level1$.next(+params['level1']);
            }
            if (params['level2']) {
                this.level2$.next(+params['level2']);
            }
        });
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(false);
        this.onDestroy$.complete();
    }

}
